'use client';
import dynamic from 'next/dynamic';
const MainNav = dynamic(() => import('@fm-nx/ui').then((mod) => ({ default: mod.MainNav })));
const MainNavMobile = dynamic(() => import('@fm-nx/ui').then((mod) => ({ default: mod.MainNavMobile })));
const PreviewBanner = dynamic(() => import('@fm-nx/ui').then((mod) => ({ default: mod.PreviewBanner })));

interface NavProps {
    variant?: 'light' | 'dark' | 'dark-transparent';
    preview?: boolean;
    isExpEditorMode?: boolean;
}

const Nav = (props: NavProps) => {
    const { variant = 'light', preview = false, isExpEditorMode = false } = props;
    return (
        <>
            {!isExpEditorMode && preview && <PreviewBanner preview={preview} />}
            {/* `relative` anchors the absolutely-positioned nav directly below the
                announcement banner (rendered above <main> in the root layout), so
                the header stays overlaid on the hero — shifted down by the banner's
                height — instead of overlapping the banner. With no banner present,
                the wrapper sits at the top of the page and the nav is unaffected. */}
            <div className="relative">
                <div className="hidden lg:block">
                    <MainNav variant={variant} />
                </div>
                <div className="block lg:hidden">
                    <MainNavMobile variant={variant} />
                </div>
            </div>
        </>
    );
};

export default Nav;
